import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { RoleBasedAccess } from './RoleBasedAccess'

const getRedirectPathFromLocation = (location) => {
  const path = `${location.pathname}${location.search}${location.hash || ''}`
  return path.startsWith('/') ? path : null
}

const isAuthFlowPath = (pathname) =>
  pathname === '/login' || pathname === '/oauth2/callback/success'

export default function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth()
  const location = useLocation()

  if (!isAuthenticated) {
    if (!isAuthFlowPath(location.pathname)) {
      const redirectPath = getRedirectPathFromLocation(location)
      if (redirectPath) {
        sessionStorage.setItem('redirectPath', redirectPath)
      }
    }
    return <Navigate to='/login' replace />
  }

  return children
}
export const RoleProtectedRoute = ({ children, allowedRoles = [] }) => {
  return (
    <ProtectedRoute>
      <RoleBasedAccess
        allowedRoles={allowedRoles}
        fallback={<Navigate to='/unauthorized' replace />}
      >
        {children}
      </RoleBasedAccess>
    </ProtectedRoute>
  )
}

